import React from "react";

import { fileUpload } from "utils";

import { AdminSection, Col, Form, Input, Option, Row, Select, TextArea, TextEditor, UploadImage } from "components";

export const MethodGeneralTab = ({
  applications,
  imageSuccess,
  imageURL,
  method,
  setImageSuccess,
  setImageURL,
  setLoading,
  t,
  updateContent,
  updatePostSuggestion,
}) => {
  const biodiversityEnum = t("enums:biodiversity", { returnObjects: true });

  return (
    <>
      <AdminSection headline="Basic method information" description={<>A maximum of 3 applications is allowed per type.</>} />
      <Row>
        <Col>
          <Form.Item name="image" rules={[{ required: true }]} initialValue={method ? method.image : undefined}>
            <UploadImage
              imageSuccess={imageSuccess}
              imageUrl={imageURL}
              label="Add image"
              beforeUpload={(v) => fileUpload(v, "methods", setImageSuccess, setImageURL, setLoading)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={16} md={16}>
          <Input name="title" label="Method title" rules={[{ required: true }]} initialValue={method && method.title} />
        </Col>
        <Col sm={8} md={8}>
          <Select name="active" label="Visibility" rules={[{ required: true }]} initialValue={method && method.active}>
            <Option value={true}>Enabled</Option>
            <Option value={false}>Disabled</Option>
          </Select>
        </Col>
      </Row>

      <Row>
        <Col sm={24} md={12}>
          <Select
            name="applications"
            label="Select full applications"
            rules={[{ required: true }]}
            mode="tags"
            style={{ width: "100%" }}
            initialValue={method && method.applications}
          >
            {applications.map((item, i) => (
              <Option value={item} key={i}>
                {item}
              </Option>
            ))}
          </Select>
        </Col>
        <Col sm={24} md={12}>
          <Select
            name="partialApplications"
            label="Select partial applications"
            rules={[{ required: false }]}
            mode="tags"
            style={{ width: "100%" }}
            initialValue={method && method.partialApplications}
          >
            {applications.map((item, i) => (
              <Option value={item} key={i}>
                {item}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col>
          <Select
            name="biodiversity"
            label="Select biodiversity options"
            rules={[{ required: true }]}
            mode="tags"
            style={{ width: "100%" }}
            initialValue={method && method.biodiversity}
          >
            {Object.keys(biodiversityEnum).map((k, i) => (
              <Option value={k} key={i}>
                {biodiversityEnum[k].headline}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <AdminSection headline="Basic description" />
      <Row>
        <Col>
          <TextEditor
            init={{
              height: 250,
            }}
            initialValue={method ? method.description : ""}
            onEditorChange={(v) => updateContent("description", v)}
          />
        </Col>
      </Row>

      <AdminSection
        headline="Method summary"
        description={
          <>This is a short description, which is highlighted in one of three colors on the method page. It can be a maximum of 200 characters long.</>
        }
      />
      <Row>
        <Col>
          <TextArea name="summary" label="Method Summary" rules={[{ required: false }]} maxLength={200} autoSize initialValue={method && method.summary} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Select name="summaryColor" label="Method Color" rules={[{ required: true }]} initialValue={method && method.summaryColor}>
            <Option value="#3B9361" key="#3B9361">
              Green
            </Option>
            <Option value="#E69B48" key="#E69B48">
              Orange
            </Option>
            <Option value="#C4765C" key="#C4765C">
              Light Brown
            </Option>
          </Select>
        </Col>
      </Row>

      <AdminSection
        headline="Additional method descriptions"
        description={
          <>This information is shown when a user views method information or is recommended to use the method. The detailed description is not required.</>
        }
      />
      <AdminSection headline="Method advantages" />
      <Row>
        <Col>
          <TextEditor
            init={{
              height: 250,
            }}
            initialValue={method && method.advantages ? method.advantages : ""}
            onEditorChange={(v) => updateContent("advantages", v)}
          />
        </Col>
      </Row>

      <AdminSection headline="Method disadvantages" />
      <Row>
        <Col>
          <TextEditor
            init={{
              height: 250,
            }}
            initialValue={method ? method.disadvantages : ""}
            onEditorChange={(v) => updateContent("disadvantages", v)}
          />
        </Col>
      </Row>

      <AdminSection headline="Method CO2 storage" />
      <Row>
        <Col>
          <TextEditor
            init={{
              height: 250,
            }}
            initialValue={method ? method.co2Storage : ""}
            onEditorChange={(v) => updateContent("co2Storage", v)}
          />
        </Col>
      </Row>

      <AdminSection headline="Method proceeds" />
      <Row>
        <Col>
          <TextEditor
            init={{
              height: 250,
            }}
            initialValue={method ? method.proceeds : ""}
            onEditorChange={(v) => updateContent("proceeds", v)}
          />
        </Col>
      </Row>

      <AdminSection
        headline="Post suggestion questions"
        description={<>These questions are displayed in the coommunity suggestions card for users to select.</>}
      />
      <Row>
        <Col>
          <TextArea
            label="Question 1"
            initialValue={method && method.postSuggestion1 ? method.postSuggestion1 : ""}
            autoSize
            name="postSuggestion1"
            rules={[{ required: false }]}
            onBlur={(e) => updatePostSuggestion(e, "postSuggestion1")}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <TextArea
            label="Question 2"
            initialValue={method && method.postSuggestion2 ? method.postSuggestion2 : ""}
            autoSize
            name="postSuggestion2"
            rules={[{ required: false }]}
            onBlur={(e) => updatePostSuggestion(e, "postSuggestion2")}
          />
        </Col>
      </Row>
    </>
  );
};
